export const aboutRoutePaths = {
  about: {
    path: '/about',
    fullPath: '/about',
  },
};
